"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useIntegralPath_1 = __importDefault(require("../../hooks/useIntegralPath"));
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const IntegralResizable_1 = __importDefault(require("./IntegralResizable"));
function Integral({ integral, nucleus }) {
    const path = (0, useIntegralPath_1.default)(integral);
    const integralPreferences = (0, usePanelPreferences_1.usePanelPreferences)('integrals', nucleus);
    return ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsx)("path", { className: "line", stroke: integralPreferences.color, strokeWidth: integralPreferences.strokeWidth, fill: "none", d: path }), (0, jsx_runtime_1.jsx)(IntegralResizable_1.default, { integralData: integral, integralFormat: integralPreferences.relative.format })] }));
}
exports.default = Integral;
